import { userFeedQueryOptions } from '@/api/queries/activity';
import { useInfiniteQuery } from '@tanstack/react-query';

/**
 * Hook to fetch a user's check-in feed for their profile page
 */
export function useProfileFeed(userId: string) {
  return useInfiniteQuery(userFeedQueryOptions(userId));
}
